export default __webpack_public_path__ + "static/og_image-1e37cb66e52c7205e0362a454d17809f.jpg";